module.exports = __webpack_public_path__ + "img/Cumulativefinancing.e5a672b3.png";